<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <!-- บริษัท -->
              <v-select
                v-model="Company"
                :items="CompanyItem"
                dense
                outlined
                @change="getDataBranch(Company)"
                hide-details
                                  clearable
              clear-icon="mdi-close-circle"
                label="บริษัท"
                class="ma-2"
              ></v-select>
              <!-- สาขา -->
              <v-select
                v-model="Branch"
                :items="BranchItem"
                @change="getDataDepartment(Branch)"
                dense
                outlined
                hide-details
                                  clearable
              clear-icon="mdi-close-circle"
                label="สาขา"
                class="ma-2"
              ></v-select>
              <!-- แผนก -->
              <v-select
                v-model="Department"
                :items="DepartmentItem"
                @change="departmentCheckSearch(Department)"
                dense
                outlined
                hide-details
                                  clearable
              clear-icon="mdi-close-circle"
                label="แผนก"
                class="ma-2"
              ></v-select>
            </v-sheet>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <!-- ประเภทการลา -->
              <v-select
                v-model="leaveType"
                :items="itemsLeaveTypeSelect"
                dense
                outlined
                hide-details
                label="ประเภทลา"
                  clearable
              clear-icon="mdi-close-circle"
                class="ma-2"
              ></v-select>
              <!-- วัน -->
              <!-- <v-select
                v-model="day"
                :items="dayName"
                dense
                outlined
                hide-details
                clearable
                clear-icon="mdi-close-circle"
                label="วัน"
                class="ma-2"
              ></v-select> -->
              <!-- เดือน -->
              <v-select
                v-model="monthStart"
                :items="monthNameTH"
                dense
                outlined
                hide-details
                label="เดือนเริ่มต้น"
                class="ma-2"
                clearable
              clear-icon="mdi-close-circle"
              ></v-select>
              <v-select
                v-model="monthEnd"
                :items="monthNameTH"
                dense
                outlined
                hide-details
                label="เดือนที่สิ้นสุด"
                class="ma-2"
                clearable
              clear-icon="mdi-close-circle"
              ></v-select>
              <!-- ปี -->
              <v-select
                v-model="year"
                :items="yearsNumber"
                dense
                outlined
                hide-details
                label="ปี"
                class="ma-2"
              ></v-select>
              <!-- ค้นหา -->
             <v-btn
                class="mt-2"
                elevation="2"
                color="info"
                text
                @click="getData()"
              >
                <v-icon left>mdi-calendar-search</v-icon>
                ค้นหา
              </v-btn>
            </v-sheet>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <v-btn
              :loading="!dataReady"
              :disabled="!dataReady"
              color="green"
              class="white--text"
              @click="dialogAdd = true"
            >
              เพิ่มข้อมูล
              <v-icon right dark> mdi-plus </v-icon>
            </v-btn>
            <v-btn
              :loading="!dataReady"
              :disabled="!dataReady"
              color="blue-grey"
              class="white--text"
              @click="exportLeave()"
            >
              Download
              <v-icon right dark> mdi-cloud-download </v-icon>
            </v-btn>
            <v-btn
              :loading="!dataReady"
              :disabled="!dataReady"
              color="blue-grey"
              class="white--text"
              @click="getData()"
            >
              reload
              <v-icon right dark> mdi-reload </v-icon>
            </v-btn>
          </v-col>

          <v-col cols="6">
            <v-text-field
              v-model="searchAll"
              dense
              outlined
              append-icon="mdi-magnify"
              label="ค้นหา รายชื่อ"
            ></v-text-field>
          </v-col>
        </v-row>
          <!-- data table -->

        <!-- ADD -->
        <v-dialog v-model="dialogAdd" max-width="80%">
          <v-card>
            <v-card-title>
              <span class="headline">สร้างใบลาสำหรับ Admin</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <span>*กรุณาเลือกพนักงาน</span>
                 <v-row>
                    <v-col cols="10">
                      <v-autocomplete
                      v-model="profile"
                      :items="dataItemEmployee"
                      :rules="nameRules"
                      dense
                      outlined
                      clear-icon="mdi-close-circle"
                      prepend-icon="mdi-account-star"
                    ></v-autocomplete>
                    </v-col>
                    <v-col cols="2">
                     <v-btn
                        elevation="2"
                        color="info"
                        text
                         @click="getDataLeaveByEmployee()"
                      >
                        <v-icon left>mdi-calendar-search</v-icon>
                        ค้นหา
                      </v-btn>
                    </v-col>
                </v-row>

              <!-- </v-container> -->
                <!-- start -->
              <!-- </v-container> -->

              <!-- <v-container fluid> -->
                <v-divider class="mx-0" style="background-color: #ffffff"></v-divider>
                <!-- <form> -->

                <v-form ref="form_add" v-model="valid_add" lazy-validation>
                  <v-select
                    @change="calculateStartEndDate()"
                    v-model="formAdd.leaveTypeCode"
                    :items="itemsLeaveTypeQuota"
                    :rules="nameRules"
                    prepend-icon="mdi-beach"
                    label="เลือก ประเภทการลา"
                    clearable
                    clear-icon="mdi-close-circle"
                    outlined
                    dense
                  ></v-select>
                  <v-divider
                    class="mx-0"
                    style="background-color: #ffffff"
                  ></v-divider>
                  <b>
                    <v-checkbox
                      v-model="formAdd.leaveIssueBeforeDay"
                      @click="calculateIssueBeforeDay()"
                      label="ท่านต้องการให้สิทธิ์ลาย้อนหลัง 180 วัน"
                    ></v-checkbox>
                    <!-- <v-alert
                    border="top"
                    colored-border
                    type="warning"
                    elevation="2"
                    v-if="formAdd.leaveIssueBeforeDay"
                  >
                    ใช้สิทธิ์การลาย้อนหลังสามารถลาย้อนหลังได้ 35 วันนับจากวันปัจจุบัน
                    โปรดพิจารณาห้ามเลือก หากไม่จำเป็น ระบบจะบันทึกประเภทนี้เป็นลาย้อนหลัง
                  </v-alert>
                  <v-alert
                    border="top"
                    colored-border
                    type="warning"
                    elevation="2"
                    v-if="formAdd.leaveIssueBeforeDay"
                  >
                    ยกเว้น ประเภทลาป่วยสามารถใช้สิทธิ์ลาย้อนหลังได้ 3 วันนับจากวันปัจจุบันจึงไม่จำเป็นต้องเลือก ใช้สิทธิ์การลาย้อนหลัง
                  </v-alert> -->
                  </b>

                  <!-- start date -->
                  <v-divider style="background-color: #ffffff"></v-divider>
                  <!-- ผู้อนุมัติลา และ รับทราบการลา -->
                  <!-- <v-subheader> ผู้อนุมัติลา และ รับทราบการลา </v-subheader> -->
                  <v-menu
                    ref="menu"
                    class="mx-1"
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="auto"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="formAdd.leaveStartDate"
                        @change="calculateStartEndDate()"
                        label="ตั้งแต่วันที่เริ่มต้นลา"
                        persistent-hint
                        :rules="nameRules"
                        prepend-icon="mdi-calendar"
                        clearable
                        clear-icon="mdi-close-circle"
                        outlined
                        dense
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="formAdd.leaveStartDate"
                      @change="calculateStartEndDate()"
                      no-title
                      locale="th-th"
                      :min="dateMin"
                      :max="dateMax"
                      @input="menu = false"
                    ></v-date-picker>
                  </v-menu>

                  <!-- end date -->

                  <!-- start date haft -->
                  <v-radio-group
                    v-model="formAdd.leaveStartHalf"
                    mandatory
                    row
                    @change="calculateStartEndDate()"
                  >
                    <v-radio label="ช่วงเช้า" value="T" checked></v-radio>
                    <v-radio label="ช่วงบ่าย" value="F"></v-radio>
                  </v-radio-group>

                  <!-- end date haft -->

                  <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="formAdd.leaveEndDate"
                        @change="calculateStartEndDate()"
                        label="ถึงวันที่ สิ้นสุดลา"
                        persistent-hint
                        :rules="nameRules"
                        prepend-icon="mdi-calendar"
                        clearable
                        clear-icon="mdi-close-circle"
                        outlined
                        dense
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="formAdd.leaveEndDate"
                      @change="calculateStartEndDate()"
                      no-title
                      locale="th-th"
                      :min="formAdd.leaveStartDate"
                      :max="dateMax"
                      @input="menu1 = false"
                    ></v-date-picker>
                  </v-menu>
                  <v-radio-group
                    v-model="formAdd.leaveEndtHalf"
                    mandatory
                    row
                    @change="calculateStartEndDate()"
                  >
                    <v-radio label="ช่วงเช้า" value="F"></v-radio>
                    <v-radio label="ช่วงบ่าย" value="T" checked></v-radio>
                  </v-radio-group>

                  <v-row>
                    <v-col cols="6">
                      <v-subheader>สรุปจำนวนวันลา</v-subheader>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                        v-model="formAdd.leaveSummaryDay"
                        dense
                        readonly
                        outlined
                        disable
                        suffix="วัน"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-divider
                    class="mx-0"
                    style="background-color: #ffffff"
                  ></v-divider>
                  <!-- ผู้อนุมัติลา และ รับทราบการลา -->
                  <v-subheader> ผู้อนุมัติลา และ รับทราบการลา </v-subheader>
                  <v-select
                    v-model="formAdd.empCodeHeader"
                    :items="dataItemHeader"
                    :rules="nameRules"
                    dense
                    readonly
                    outlined
                    clear-icon="mdi-close-circle"
                    prepend-icon="mdi-account-star"
                    label="*ส่งอนุมัติ หัวหน้างาน"
                  ></v-select>
                  <v-select
                    v-model="formAdd.empCodeHeaderCC1"
                    :items="dataItemHeader"
                    dense
                    readonly
                    outlined
                    prepend-icon="mdi-account-star"
                    label="ส่งรับทราบ หัวหน้างาน"
                  ></v-select>

                  <v-divider
                    class="mx-0"
                    style="background-color: #ffffff"
                  ></v-divider>
                  <v-subheader> รายละเอียด </v-subheader>
                  <v-text-field
                    v-model="formAdd.leavePhoneEmergency"
                    maxlength="10"
                    label="เบอร์โทรศัพท์ *"
                    :rules="numberRules"
                    prepend-icon="mdi-cellphone"
                    clear-icon="mdi-close-circle"
                    clearable
                    counter="10"
                    outlined
                    required
                  ></v-text-field>
                  <v-textarea
                    v-model="formAdd.leaveDetail"
                    maxlength="100"
                    rows="3"
                    row-height="25"
                    outlined
                    prepend-icon="mdi-message-text"
                    :rules="nameRules"
                    clearable
                    clear-icon="mdi-close-circle"
                    label="รายละเอียด"
                  ></v-textarea>
                </v-form>

                <v-divider class="mx-0" style="background-color: #ffffff"></v-divider>
                <v-subheader>แนบไฟล์ 2 ไฟล์ (ทางเลือก)</v-subheader>
                <v-file-input
                  v-model="files"
                  show-size
                  accept="image/*,.pdf"
                  placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
                  :rules="imageRules"
                  outlined
                  dense
                  required
                ></v-file-input>
                <v-file-input
                  v-model="files2"
                  show-size
                  accept="image/*,.pdf"
                  :rules="imageRules"
                  outlined
                  dense
                  placeholder="แนบไฟล์ (ไม่เกิน 5 MB)"
                  required
                ></v-file-input>
                <v-divider class="mx-0" style="background-color: #ffffff"></v-divider>
                <v-alert border="bottom" colored-border type="warning" elevation="2">
                การลาฉุกเฉินจะไม่คิดคำนวน <b>*การลาล่วงหน้า*</b> โปรดพิจารณา <b>ห้ามเลือก
                หากไม่จำเป็น</b>
              </v-alert>
                <b>
                  <v-checkbox
                    v-model="formAdd.leaveEmergency"
                    label=" ท่านต้องการลาฉุกเฉินหรือไม่"
                  ></v-checkbox>
                </b>
                <v-divider class="mx-0" style="background-color: #ffffff"></v-divider>
              <v-row>
              <v-col class="text-left">

              <v-btn
                elevation="2"
                x-large
                color="dark darken-1"
                text
                @click="dialogAdd = false"
              >
                <v-icon left> mdi-minus-box-outline</v-icon>
                ปิด
              </v-btn>

              </v-col>
              <v-col class="text-right">
                <v-btn
                  elevation="2"
                  x-large
                  color="success"
                  :disabled="!valid_add"
                  text
                  @click="submit()"
                >
                  <v-icon left>mdi-checkbox-marked-circle</v-icon>
                  ส่งใบลา
                </v-btn>
              </v-col>
              </v-row>
              </v-container>

              <!-- </v-form> -->

              <!-- end -->
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end add -->

        <v-col cols="12">
          <v-alert dense type="info" icon="mdi-account-switch">
            รายการ <strong>ขออนุมัติลา</strong>
          </v-alert>
          <v-card elevation="7" v-if="dataReady">
            <v-card-text>
              <v-data-table
                :headers="columnsItem"
                :items="dataItem"
                :search="searchAll"
                :items-per-page="10"
              >
              <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_date_1(item.CREATE_DATE) }}
                </template>
              <template v-slot:[`item.leaveEmergency`]="{ item }">
                  <v-btn
            color="warning"
            fab
            small
            dark
              v-if="item.leaveEmergency ==='True'"
          >
            <v-icon>mdi-alert</v-icon>
          </v-btn>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-btn
                    color="info"
                    @click="getDataById(item), dialog=true"
                  >
                    ตรวจสอบ
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div v-if="!dataReady" class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-col>

        <v-col cols="12">
          <v-alert dense type="success" icon="mdi-account-switch">
            รายการ <strong>อนุมัติลา</strong>
          </v-alert>
          <v-card elevation="7" v-if="dataReady">
            <v-card-text>
              <v-data-table
                :headers="columnsItem"
                :items="dataItemApprove"
                :search="searchAll"
                :items-per-page="10"
              >
              <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_date_1(item.CREATE_DATE) }}
                </template>
              <template v-slot:[`item.leaveEmergency`]="{ item }">
                  <v-btn
            color="warning"
            fab
            small
            dark
              v-if="item.leaveEmergency ==='True'"
          >
            <v-icon>mdi-alert</v-icon>
          </v-btn>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-btn
                    color="info"
                    @click="getDataById(item), dialogDetail=true"
                  >
                    ตรวจสอบ
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div v-if="!dataReady" class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-col>

        <v-col cols="12">
          <v-alert dense type="error" icon="mdi-account-switch">
            รายการ <strong>ไม่อนุมัติลา</strong>
          </v-alert>
          <v-card elevation="7" v-if="dataReady">
            <v-card-text>
              <v-data-table
                :headers="columnsItem"
                :items="dataItemUnApprove"
                :search="searchAll"
                :items-per-page="10"
              >
              <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_date_1(item.CREATE_DATE) }}
                </template>
              <template v-slot:[`item.leaveEmergency`]="{ item }">
                    <v-btn
                  color="warning"
                  fab
                  small
                  dark
                  v-if="item.leaveEmergency ==='True'"
                >
                  <v-icon>mdi-alert</v-icon>
                </v-btn>
              </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-btn
                    color="info"
                    @click="getDataById(item), dialogDetail=true"
                  >
                    ตรวจสอบ
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div v-if="!dataReady" class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-col>

        <v-col cols="12">
          <v-alert dense type="error" icon="mdi-account-switch">
            รายการ <strong>ยกเลิกลา</strong>
          </v-alert>
          <v-card elevation="7" v-if="dataReady">
            <v-card-text>
              <v-data-table
                :headers="columnsItem"
                :items="dataItemCancel"
                :search="searchAll"
                :items-per-page="10"
              >
              <template v-slot:[`item.CREATE_DATE`]="{ item }">
                    {{ format_date_1(item.CREATE_DATE) }}
                </template>
              <template v-slot:[`item.leaveEmergency`]="{ item }">
                    <v-btn
                  color="warning"
                  fab
                  small
                  dark
                  v-if="item.leaveEmergency ==='True'"
                >
                  <v-icon>mdi-alert</v-icon>
                </v-btn>
              </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-btn
                    color="info"
                    @click="getDataById(item), dialogDetail=true"
                  >
                    ตรวจสอบ
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div v-if="!dataReady" class="text-center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </v-col>

        <!-- end data table -->

        <!-- รายละเอียด -->
        <v-dialog v-model="dialog" persistent max-width="80%">
          <v-card>
            <v-card-title>
              <span class="headline">ตรวจสอบข้อมูล</span>
            </v-card-title>
            <v-card-text>
              <v-card>
                <v-row>
                  <v-col>
                    <div class="text-h5 mb-4">*ข้อมูลพนักงาน</div>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-left">ข้อมูล</th>
                            <th class="text-left">รายละเอียด</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>รหัสพนักงาน</td>
                            <td>{{ dateItemInfo.empCode }}</td>
                          </tr>
                          <tr>
                            <td>ชื่อ นามสกุล</td>
                            <td>{{ dateItemInfo.empFull_NameTH }}</td>
                          </tr>
                          <tr>
                            <td>แผนก</td>
                            <td>{{ dateItemInfo.masDepartmentName }}</td>
                          </tr>
                          <tr>
                            <td>สาขา</td>
                            <td>{{ dateItemInfo.masBranchName }}</td>
                          </tr>
                          <tr>
                            <td>บริษัท</td>
                            <td>{{ dateItemInfo.masCompanyName }}</td>
                          </tr>
                          <tr>
                            <td>หัวหน้า</td>
                            <td>{{ dateItemInfo.empFull_NameTH_approve }}</td>
                          </tr>
                          <!-- <tr>
                            <td>กะพนักงานส่งคำร้อง</td>
                            <td>
                              <v-chip class="ma-2" color="yellow" label>
                                ({{ dateItemInfo.shiftTransferOldShiftCode }})
                                {{ dateItemInfo.OldDate }}
                              </v-chip>
                            </td>
                          </tr> -->
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                  <v-col>
                    <div class="text-h5 mb-4">*โควต้าลา (รวมรายการ)</div>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-left">ประภท</th>
                            <th class="text-left">จำนวนลาคงเหลือ</th>
                          </tr>
                        </thead>
                        <tbody>
                           <tr
                              v-for="item in dataItemQuota"
                              :key="item.quotaLeaveName"
                            >
                               <td>{{ item.quotaLeaveName }}</td>
                              <td>{{ item.leaveRequest }}/{{ item.quotaLeave }}</td>
                            </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                  <v-col>
                    <div class="text-h5 mb-4">*ข้อมูลการลา</div>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-left">ข้อมูล</th>
                            <th class="text-left">รายละเอียด</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>ตั้งแต่วันที่</td>
                            <td>{{ dateItemInfo.leaveStartDate }}</td>
                          </tr>
                          <tr>
                            <td>ถึงวันที่</td>
                            <td>{{ dateItemInfo.leaveEndDate }}</td>
                          </tr>
                          <tr>
                            <td>จำนวนวันลา</td>
                            <td>{{ dateItemInfo.leaveSummaryDay }}</td>
                          </tr>
                          <tr>
                            <td>เบอร์ติดต่อ</td>
                            <td>{{ dateItemInfo.leavePhoneEmergency }}</td>
                          </tr>
                          <tr>
                            <td>รายละเอียด</td>
                            <td>{{ dateItemInfo.leaveDetail }}</td>
                          </tr>
                          <tr>
                            <td>สถานะ</td>
                            <td>{{ dateItemInfo.leaveStatus }}</td>
                          </tr>
                           <tr>
                            <td>ไฟล์แนบ</td>
                            <td> <a :href="dateItemInfo.leaveFile"  target="_blank" download v-if="dateItemInfo.leaveFile">
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-card>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                elevation="2"
                x-large
                color="dark darken-1"
                text
                @click="dialog = false"
              >
                <v-icon left> mdi-minus-box-outline</v-icon>
                ปิด
              </v-btn>
              <v-btn
                elevation="2"
                x-large
                color="success"
                text
                @click="dialog = false, approve(dateItemInfo, 'approve')"
              >
                <v-icon left> mdi-check-circle-outline</v-icon>
                อนุมัติ
              </v-btn>
              <v-btn
                elevation="2"
                x-large
                color="red"
                text
                @click="dialog = false,approve(dateItemInfo, 'unapprove')"
              >
                <v-icon left> mdi-cancel</v-icon>
                ไม่อนุมัติ
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- รายละเอียด -->
        <v-dialog v-model="dialogDetail" persistent max-width="80%">
          <v-card>
            <v-card-title>
              <span class="headline">ตรวจสอบข้อมูล</span>
            </v-card-title>
            <v-card-text>
              <v-card>
                <v-row>
                  <v-col>
                    <div class="text-h5 mb-4">*ข้อมูลพนักงาน</div>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-left">ข้อมูล</th>
                            <th class="text-left">รายละเอียด</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>รหัสพนักงาน</td>
                            <td>{{ dateItemInfo.empCode }}</td>
                          </tr>
                          <tr>
                            <td>ชื่อ นามสกุล</td>
                            <td>{{ dateItemInfo.empFull_NameTH }}</td>
                          </tr>
                          <tr>
                            <td>แผนก</td>
                            <td>{{ dateItemInfo.masDepartmentName }}</td>
                          </tr>
                          <tr>
                            <td>สาขา</td>
                            <td>{{ dateItemInfo.masBranchName }}</td>
                          </tr>
                          <tr>
                            <td>บริษัท</td>
                            <td>{{ dateItemInfo.masCompanyName }}</td>
                          </tr>
                          <tr>
                            <td>หัวหน้า</td>
                            <td>{{ dateItemInfo.empFull_NameTH_approve }}</td>
                          </tr>
                          <!-- <tr>
                            <td>กะพนักงานส่งคำร้อง</td>
                            <td>
                              <v-chip class="ma-2" color="yellow" label>
                                ({{ dateItemInfo.shiftTransferOldShiftCode }})
                                {{ dateItemInfo.OldDate }}
                              </v-chip>
                            </td>
                          </tr> -->
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                  <v-col>
                    <div class="text-h5 mb-4">*ข้อมูลการลา</div>
                    <v-simple-table>
                      <template v-slot:default>
                        <thead>
                          <tr style="background-color: #1b437c">
                            <th class="text-left">ข้อมูล</th>
                            <th class="text-left">รายละเอียด</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>ตั้งแต่วันที่</td>
                            <td>{{ dateItemInfo.leaveStartDate }}</td>
                          </tr>
                          <tr>
                            <td>ถึงวันที่</td>
                            <td>{{ dateItemInfo.leaveEndDate }}</td>
                          </tr>
                          <tr>
                            <td>จำนวนวันลา</td>
                            <td>{{ dateItemInfo.leaveSummaryDay }}</td>
                          </tr>
                          <tr>
                            <td>เบอร์ติดต่อ</td>
                            <td>{{ dateItemInfo.leavePhoneEmergency }}</td>
                          </tr>
                          <tr>
                            <td>รายละเอียด</td>
                            <td>{{ dateItemInfo.leaveDetail }}</td>
                          </tr>
                          <tr>
                            <td>สถานะ</td>
                            <td>{{ dateItemInfo.leaveStatus }}</td>
                          </tr>
                           <tr>
                            <td>ไฟล์แนบ</td>
                            <td> <a :href="dateItemInfo.leaveFile"  target="_blank" download v-if="dateItemInfo.leaveFile">
                                <b>[File Download]</b>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-row>
              </v-card>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                elevation="2"
                x-large
                color="dark darken-1"
                text
                @click="dialogDetail = false"
              >
                <v-icon left> mdi-cancel</v-icon>
                ปิด
              </v-btn>
               <v-btn
                v-if="(dateItemInfo.leaveStatus == 'approve')"
                elevation="2"
                x-large
                color="red"
                text
                @click="dialogDetail = false,approve(dateItemInfo, 'cancel')"
              >
                <v-icon left> mdi-cancel</v-icon>
                ยกเลิก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import { gmapApi } from 'vue2-google-maps'
import dayName from '../../../assets/master/Date/day.json'
import monthNameTH from '../../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../../assets/master/Date/yearsNumber.json'
import moment from 'moment'
// import LeaveRequestVue from './LeaveRequest.vue'

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile,
    gmapApi
  },
  data () {
    return {
      path: '/leave_data/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'รายการลา',
          disabled: false,
          href: '/HRM/Leave/LeaveRequest'
        }
      ],
      session: this.$session.getAll(),
      dateMax: moment().endOf('year').format('YYYY-MM-DD'),
      dateMin: moment().subtract(2, 'd').format('YYYY-MM-DD'),
      dateNow: moment().format('YYYY-MM-DD'),
      menu: false,
      modal: false,
      menu1: false,
      loading: false,
      loading2: false,
      dataReady: true,
      dialog: false,
      dialogAdd: false,
      dialogDetail: false,
      valid_add: true,
      columnsItem: [
        { text: 'รหัสพนักงาน', value: 'empCode' },
        { text: 'พนักงาน', value: 'empFull_NameTH' },
        { text: 'ประเภท', value: 'quotaLeaveName' },
        { text: 'รายละเอียด', value: 'leaveDetail' },
        { text: 'ตั้งแต่', value: 'leaveStartDate' },
        { text: 'ถึง', value: 'leaveEndDate' },
        { text: 'จำนวน', value: 'leaveSummaryDay' },
        { text: 'แผนก', value: 'masDepartmentName' },
        { text: 'สาขา', value: 'masBranchName' },
        { text: 'หัวหน้า', value: 'empFull_NameTH_approve' },
        { text: 'ลาด่วน', value: 'leaveEmergency' },
        { text: 'วันที่สร้าง', value: 'CREATE_DATE' },
        {
          text: 'ตรวจสอบ',
          value: 'action',
          sortable: false,
          align: 'center'
        }
      ],
      profile: '',
      formAdd: {
        leaveId: '',
        leaveCode: '',
        leaveStartDate: moment().format('YYYY-MM-DD'), // วันลาเริ่มต้น
        leaveStartDay: moment().format('D'), // วันลาเริ่มต้น วัน
        leaveStartMonth: moment().format('M'), // วันลาเริ่มต้น เดือน
        leaveStartYear: moment().format('YYYY'), // วันลาเริ่มต้น ปี
        leaveStartHour: '', // วันลาเริ่มต้น ชั่วโมง
        leaveStartHalf: 'T', // วันลาเริ่มต้น ครึ่งวัน
        leaveEndDate: moment().format('YYYY-MM-DD'), // วันลาถึงวันที่
        leaveEndDay: moment().format('D'), // วันลาถึงวันที่ วัน
        leaveEndMonth: moment().format('M'), // วันลาถึงวันที่ เดือน
        leaveEndYear: moment().format('YYYY'), // วันลาถึงวันที่ ปี
        leaveEndHour: '', // วันลาถึงวันที่ ชั่วโมง
        leaveEndtHalf: 'T', // วันลาถึงวันที่ ครึ่งวัน
        empCode: '',
        empCodeHeader: null, // ส่งมอบคนที่1
        empCodeHeaderCC1: null, // ส่งมอบคนที่2
        leaveStatus: '',
        leaveDetail: '-', // รายละเอียด
        leaveRemark: '',
        leavePhoneEmergency: '', // เบอร์ติดต่อฉุกเฉิน
        leaveSummaryDay: 1, // จำนวนวันลา
        leaveTypeCode: null, // ประเภทการลา
        quotaLeaveName: '',
        leaveFile: '',
        leaveFile2: '',
        leaveEmergency: false,
        leaveIssueBeforeDay: false
      },
      dataItem: [],
      dataItemApprove: [],
      dataItemUnApprove: [],
      dataItemCancel: [],
      dateItemInfo: [],
      dataItemQuota: [],
      leaveTypeItem: [],
      dataItemEmployee: [],
      dataItemHeader: [],
      leaveTypeCode: '',
      itemsLeaveTypeSelect: [],
      leaveType: '',
      BranchItem: [], // สาขา
      DepartmentItem: [], // แผนก
      CompanyItem: [], // บริษัท
      Company: '', // บริษัท
      Branch: '', // บริษัท
      Department: '', // บริษัท
      year: '',
      monthStart: '',
      monthEnd: '',
      day: '',
      disableYear: true,
      disableMonth: true,
      dayName: dayName,
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,
      profileHeader: [],
      itemsLeave: [],
      itemsLeaveQuota: [],
      itemsLeaveSelect: [],
      itemsLeaveTypeQuota: [],
      itemsLeaveTypeSelectByProfile: [],
      itemsQuota: [],
      files: null,
      files2: null,
      imageHeadHRM: '',
      imageUrlBack: '',
      imageUrlleve: '',
      select: '',
      sumLeave: 0,
      nameRules: [(v) => !!v || 'Input is required'],
      numberRules: [
        (v) =>
          (!isNaN(parseFloat(v)) && v >= 0 && v <= 9999999999) ||
          'กรุณา กรอกเป็นตัวเลข 0-9',
        (v) => (v && v.length === 10) || 'Max 10 characters'
      ],
      imageRules: [
        (value) =>
          !value || value.size < 2000000 || 'size should be less than 2 MB!'
      ]
    }
  },
  async mounted () {
    this.monthStart = this.getMonthTh()
    this.monthEnd = this.getMonthTh()
    let date = new Date()
    this.year = moment().format('YYYY')
    this.day = date.getDate()
    await this.getData()

    await this.getDataCompany()
    await this.getDataBranch()
    await this.getDataDepartment()
    await this.getDataLeaveType()
    await this.getEmployee()
  },
  methods: {
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break

        default:
          break
      }
    },
    async getData () {
      await this.getDataWaiting()
      await this.getDataApprove()
      await this.getDataUnApprove()
      await this.getDataCancel()
    },
    async getDataWaiting () {
      this.dataItem = []

      this.leaveType = (this.leaveType) ? this.leaveType : null
      this.monthStart = (this.monthStart) ? this.monthStart : null
      this.monthEnd = (this.monthEnd) ? this.monthEnd : null
      this.Department = (this.Department) ? this.Department : null
      this.Branch = (this.Branch) ? this.Branch : null
      this.Company = (this.Company) ? this.Company : null

      var leaveTypeSerch = (this.leaveType !== null) ? '&leaveTypeCode=' + this.leaveType : ''
      var monthSearch = (this.monthStart !== null) ? '&searchStartMonth=' + this.getMonthThToINT(this.monthStart) : ''
      var monthEndSearch = (this.monthEnd !== null) ? '&searchEndMonth=' + this.getMonthThToINT(this.monthEnd) : ''
      // var daySearch = (this.day !== null) ? '&leaveStartDay=' + this.day : ''
      var Department = (this.Department !== null) ? '&masDepartmentName=' + this.Department : ''
      var Branch = (this.Branch !== null) ? '&masBranchName=' + this.Branch : ''
      var Company = (this.Company !== null) ? '&masCompanyName=' + this.Company : ''
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + '/leave_data/get?leaveStatus=waiting' +
          '&leaveStartYear=' +
            this.year + leaveTypeSerch + monthSearch + monthEndSearch +
            Company + Branch + Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItem = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    async getDataApprove () {
      this.dataItemApprove = []

      this.leaveType = (this.leaveType) ? this.leaveType : null
      this.monthStart = (this.monthStart) ? this.monthStart : null
      this.monthEnd = (this.monthEnd) ? this.monthEnd : null
      this.Department = (this.Department) ? this.Department : null
      this.Branch = (this.Branch) ? this.Branch : null
      this.Company = (this.Company) ? this.Company : null

      var leaveTypeSerch = (this.leaveType !== null) ? '&leaveTypeCode=' + this.leaveType : ''
      var monthSearch = (this.monthStart !== null) ? '&searchStartMonth=' + this.getMonthThToINT(this.monthStart) : ''
      var monthEndSearch = (this.monthEnd !== null) ? '&searchEndMonth=' + this.getMonthThToINT(this.monthEnd) : ''
      // var daySearch = (this.day !== null) ? '&leaveStartDay=' + this.day : ''
      var Department = (this.Department !== null) ? '&masDepartmentName=' + this.Department : ''
      var Branch = (this.Branch !== null) ? '&masBranchName=' + this.Branch : ''
      var Company = (this.Company !== null) ? '&masCompanyName=' + this.Company : ''

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + 'get?leaveStatus=approve' +
          '&leaveStartYear=' +
            this.year + leaveTypeSerch + monthSearch + monthEndSearch +
            Company + Branch + Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItemApprove = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    async getDataUnApprove () {
      this.dataItemUnApprove = []

      this.leaveType = (this.leaveType) ? this.leaveType : null
      this.monthStart = (this.monthStart) ? this.monthStart : null
      this.monthEnd = (this.monthEnd) ? this.monthEnd : null

      this.Department = (this.Department) ? this.Department : null
      this.Branch = (this.Branch) ? this.Branch : null
      this.Company = (this.Company) ? this.Company : null

      var leaveTypeSerch = (this.leaveType !== null) ? '&leaveTypeCode=' + this.leaveType : ''
      var monthSearch = (this.monthStart !== null) ? '&searchStartMonth=' + this.getMonthThToINT(this.monthStart) : ''
      var monthEndSearch = (this.monthEnd !== null) ? '&searchEndMonth=' + this.getMonthThToINT(this.monthEnd) : ''
      // var daySearch = (this.day !== null) ? '&leaveStartDay=' + this.day : ''
      var Department = (this.Department !== null) ? '&masDepartmentName=' + this.Department : ''
      var Branch = (this.Branch !== null) ? '&masBranchName=' + this.Branch : ''
      var Company = (this.Company !== null) ? '&masCompanyName=' + this.Company : ''

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + 'get?leaveStatus=unapprove' +
           '&leaveStartYear=' +
            this.year + leaveTypeSerch + monthSearch + monthEndSearch +
            Company + Branch + Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItemUnApprove = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    async getDataCancel () {
      this.dataItemCancel = []

      this.leaveType = (this.leaveType) ? this.leaveType : null
      this.monthStart = (this.monthStart) ? this.monthStart : null
      this.monthEnd = (this.monthEnd) ? this.monthEnd : null

      this.Department = (this.Department) ? this.Department : null
      this.Branch = (this.Branch) ? this.Branch : null
      this.Company = (this.Company) ? this.Company : null

      var leaveTypeSerch = (this.leaveType !== null) ? '&leaveTypeCode=' + this.leaveType : ''
      var monthSearch = (this.monthStart !== null) ? '&searchStartMonth=' + this.getMonthThToINT(this.monthStart) : ''
      var monthEndSearch = (this.monthEnd !== null) ? '&searchEndMonth=' + this.getMonthThToINT(this.monthEnd) : ''
      // var daySearch = (this.day !== null) ? '&leaveStartDay=' + this.day : ''
      var Department = (this.Department !== null) ? '&masDepartmentName=' + this.Department : ''
      var Branch = (this.Branch !== null) ? '&masBranchName=' + this.Branch : ''
      var Company = (this.Company !== null) ? '&masCompanyName=' + this.Company : ''

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + 'get?leaveStatus=cancel' +
           '&leaveStartYear=' +
            this.year + leaveTypeSerch + monthSearch + monthEndSearch +
            Company + Branch + Department,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItemCancel = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
    },
    async getDataById (item) {
      this.dateItemInfo = []
      this.dataItemQuota = []
      this.dateItemInfo = item
      var leaveRquest = await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/leave_data/getByEmpWaitingApprove?empCode=' +
            item.empCode,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )

      var quota = await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/leave_quota/' +
            'position_lavel_get?positionTypeCode=' +
            item.positionTypeCode +
            '&leavePrivilege=F',
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )

      for (var i = 0; i < quota.data.length; i++) {
        var d = quota.data[i]
        var s = {}
        var sum = 0
        if (leaveRquest.data.length > 0) {
          let quoSum = 0
          let quoLimit = 0
          leaveRquest.data.forEach(leave => {
            if (d.quotaLeaveCode === leave.leaveTypeCode) {
              quoSum += leave.leaveSummaryDay
              quoLimit = d.quotaLeave
            } else {
              quoLimit = d.quotaLeave
            }
          })
          sum = quoLimit - quoSum
        } else {
          sum = d.quotaLeave
        }
        s.quotaLeaveName = d.quotaLeaveName
        s.leaveRequest = sum
        s.quotaLeave = d.quotaLeave
        this.dataItemQuota.push(s)
      }
    },
    async approve (item, status) {
      // console.log('item', item)
      // console.log('status', status)
      this.$swal({
        title: 'ท่านต้องการ ' + status + ' ใช่หรือไม่',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          let ds = {
            leaveStatus: status,
            LAST_USER: this.$session.getAll().data.userName
          }
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + "/leave_data/edit/" + item.leaveId,
              ds,
              {
                headers: {
                  'Application-Key': this.$session.getAll().ApplicationKey
                }
              }
            )
            .then(async (response) => {
              await this.setUpBeforeSendLineApproveUnapprove(item, status)
              await this.getData()
              this.dataReady = true
            })
          // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log(error)
            })
        })
        .catch((error) => {
          console.log('error approve : ', error)
          this.$refs.inputFile.value = null

          this.dataReady = true
        })
    },
    async setUpBeforeSendLineApproveUnapprove (item, status) {
      var statusmessage = 'อนุมัติ'
      var color = '017305'
      if (status === 'unapprove') {
        statusmessage = 'ไม่อนุมัติ'
        color = '800305'
      }
      if (status === 'cancel') {
        statusmessage = 'ยกเลิก'
        color = '800305'
      }
      var payload = [
        {
          type: 'flex',
          altText: item.empFull_NameTH + '[' + statusmessage + item.quotaLeaveName + ']',
          contents: {
            type: 'bubble',
            size: 'giga',
            body: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'image',
                  url: item.leaveImgUrl,
                  size: '60%',
                  gravity: 'center'
                }
              ],
              paddingAll: '0px'
            },
            footer: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text:
                        'คำขออนุมัติ ' + item.quotaLeaveName,
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: statusmessage,
                      wrap: true,
                      align: 'center',
                      size: '26px',
                      color: '#' + color
                    }
                  ],
                  margin: '10px'
                },
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: item.empFull_NameTH,
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text:
                        'เริ่มวันที่ ' +
                        item.leaveStartDate +
                        ' ถึง' +
                        item.leaveEndDate,
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: 'จำนวนวันลา ' + item.leaveSummaryDay + ' วัน',
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: 'วันที่ทำรายการ ' + moment().format('YYYY-MM-DD HH:mm:ss'),
                      wrap: true,
                      align: 'center'
                    },
                    {
                      'type': 'text',
                      'text': statusmessage + 'จาก ฝ่าย' + this.$session.getAll().data.masDepartmentName,
                      'wrap': true,
                      'align': 'center',
                      'weight': 'bold',
                      color: '#' + color
                    }
                  ],
                  margin: '10px'
                }
              ]
            }
          }
        }
      ]
      await this.setlineUser(item, payload)
      this.dataReady = false
    },
    async setlineUser (item, payload) {
      if (item.userLineuserId) {
        await this.sendLinePush(payload, item.userLineuserId)
      }
      if (item.userLineuserIdHeader) {
        await this.sendLinePush(payload, item.userLineuserIdHeader)
      }
    },
    async sendLinePush (payload, lineid) {
      const msgPayload = {
        to: lineid,
        messages: payload
      }
      let dt = {
        payload: msgPayload
      }
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/line/push_message",
          dt, {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          // console.log(response)
        })
      // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          // console.log('linenotify: ', error)
        })
    },
    async clear () {
      console.log('clear')
      this.Company = ''
      this.Branch = ''
      this.Department = ''
      this.leaveType = ''
      await this.getData()
    },
    // บริษัท
    async getDataCompany () {
      this.CompanyItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_company/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('Company', response.data)
          this.dataReady = true
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masCompanyName
            s.value = d.masCompanyName
            d = s
            this.CompanyItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    // สาขา
    async getDataBranch () {
      this.BranchItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_branch/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('Company', response.data)
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masBranchName
            s.value = d.masBranchName
            d = s
            this.BranchItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    // แผนก
    async getDataDepartment () {
      this.DepartmentItem = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/master_department/getItem",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('getDataDepartment : ', this.DepartmentItem)
          let rs = response.data
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            s.text = d.masDepartmentName
            s.value = d.masDepartmentName
            d = s
            this.DepartmentItem.push(d)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    async getDataLeaveType () {
      var positionTypeCode = this.$session.getAll().data.positionTypeCode
      // Clear Data ทุกครั้ง
      this.itemsLeaveTypeSelect = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/leave_quota/' +
            'position_lavel_get?positionTypeCode=' + positionTypeCode,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          if (response.data) {
            let rs = response.data
            console.log('getDataLeaveType', rs)
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              var s = {}
              s.text = d.quotaLeaveName
              s.value = d.quotaLeaveCode
              d = s
              this.itemsLeaveTypeSelect.push(d)
            }
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    departmentCheckSearch (departmentCheckSearch) {
      if (departmentCheckSearch) {
        this.disableSearch = true
      }
    },
    async exportLeave () {
      var dataItme = []
      var dataApprove = []
      var dataUnapprove = []
      var dataItemCancel = []
      this.dataItem.forEach((element) => {
        let s = {
          'รหัสพนักงาน': element.empCode,
          'ชื่อพนักงาน': element.empFull_NameTH,
          'แผนก': element.masDepartmentName,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'ประเภทลา': element.quotaLeaveName,
          'เริ่มวัน': element.leaveStartDay,
          'เริ่มเดือน': element.leaveStartMonth,
          'เริ่มปี': element.leaveStartYear,
          'วัน/เดือน/ปี': element.leaveStartDate,
          'สิ้นสุดวัน': element.leaveEndDay,
          'สิ้นสุดเดือน': element.leaveEndMonth,
          'สิ้นสุดปี': element.leaveEndYear,
          'สิ้นสุดวันเดือนปี': element.leaveEndDate,
          'จำนวนวันลา': element.leaveSummaryDay,
          'หัวหน้า': element.empFull_NameTH_approve,
          'เบอร์ติดต่อ': element.leavePhoneEmergency,
          'รายละเอียด': element.leaveDetail,
          'สถานะการลา': element.leaveStatus,
          'ไฟล์ที่แนบ1': element.leaveFile,
          'ไฟล์ที่แนบ2': element.leaveFile2,
          'วันที่สร้างข้อมูล': element.CREATE_DATE,
          'วันที่แก้ไขข้อมูล': element.LAST_DATE,
          'ผู้แก้ไข': element.LAST_USER
        }
        dataItme.push(s)
      })
      this.dataItemApprove.forEach((element) => {
        let s = {
          'รหัสพนักงาน': element.empCode,
          'ชื่อพนักงาน': element.empFull_NameTH,
          'แผนก': element.masDepartmentName,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'ประเภทลา': element.quotaLeaveName,
          'เริ่มวัน': element.leaveStartDay,
          'เริ่มเดือน': element.leaveStartMonth,
          'เริ่มปี': element.leaveStartYear,
          'วัน/เดือน/ปี': element.leaveStartDate,
          'สิ้นสุดวัน': element.leaveEndDay,
          'สิ้นสุดเดือน': element.leaveEndMonth,
          'สิ้นสุดปี': element.leaveEndYear,
          'สิ้นสุดวันเดือนปี': element.leaveEndDate,
          'จำนวนวันลา': element.leaveSummaryDay,
          'หัวหน้า': element.empFull_NameTH_approve,
          'เบอร์ติดต่อ': element.leavePhoneEmergency,
          'รายละเอียด': element.leaveDetail,
          'สถานะการลา': element.leaveStatus,
          'ไฟล์ที่แนบ1': element.leaveFile,
          'ไฟล์ที่แนบ2': element.leaveFile2,
          'วันที่สร้างข้อมูล': element.CREATE_DATE,
          'วันที่แก้ไขข้อมูล': element.LAST_DATE,
          'ผู้แก้ไข': element.LAST_USER
        }
        dataApprove.push(s)
      })
      this.dataItemUnApprove.forEach((element) => {
        let s = {
          'รหัสพนักงาน': element.empCode,
          'ชื่อพนักงาน': element.empFull_NameTH,
          'แผนก': element.masDepartmentName,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'ประเภทลา': element.quotaLeaveName,
          'เริ่มวัน': element.leaveStartDay,
          'เริ่มเดือน': element.leaveStartMonth,
          'เริ่มปี': element.leaveStartYear,
          'วัน/เดือน/ปี': element.leaveStartDate,
          'สิ้นสุดวัน': element.leaveEndDay,
          'สิ้นสุดเดือน': element.leaveEndMonth,
          'สิ้นสุดปี': element.leaveEndYear,
          'สิ้นสุดวันเดือนปี': element.leaveEndDate,
          'จำนวนวันลา': element.leaveSummaryDay,
          'หัวหน้า': element.empFull_NameTH_approve,
          'เบอร์ติดต่อ': element.leavePhoneEmergency,
          'รายละเอียด': element.leaveDetail,
          'สถานะการลา': element.leaveStatus,
          'ไฟล์ที่แนบ1': element.leaveFile,
          'ไฟล์ที่แนบ2': element.leaveFile2,
          'วันที่สร้างข้อมูล': element.CREATE_DATE,
          'วันที่แก้ไขข้อมูล': element.LAST_DATE,
          'ผู้แก้ไข': element.LAST_USER
        }
        dataUnapprove.push(s)
      })
      this.dataItemCancel.forEach((element) => {
        let s = {
          'รหัสพนักงาน': element.empCode,
          'ชื่อพนักงาน': element.empFull_NameTH,
          'แผนก': element.masDepartmentName,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'ประเภทลา': element.quotaLeaveName,
          'เริ่มวัน': element.leaveStartDay,
          'เริ่มเดือน': element.leaveStartMonth,
          'เริ่มปี': element.leaveStartYear,
          'วัน/เดือน/ปี': element.leaveStartDate,
          'สิ้นสุดวัน': element.leaveEndDay,
          'สิ้นสุดเดือน': element.leaveEndMonth,
          'สิ้นสุดปี': element.leaveEndYear,
          'สิ้นสุดวันเดือนปี': element.leaveEndDate,
          'จำนวนวันลา': element.leaveSummaryDay,
          'หัวหน้า': element.empFull_NameTH_approve,
          'เบอร์ติดต่อ': element.leavePhoneEmergency,
          'รายละเอียด': element.leaveDetail,
          'สถานะการลา': element.leaveStatus,
          'ไฟล์ที่แนบ1': element.leaveFile,
          'ไฟล์ที่แนบ2': element.leaveFile2,
          'วันที่สร้างข้อมูล': element.CREATE_DATE,
          'วันที่แก้ไขข้อมูล': element.LAST_DATE,
          'ผู้แก้ไข': element.LAST_USER
        }
        dataItemCancel.push(s)
      })
      var data = XLSX.utils.json_to_sheet(dataItme)
      var unapprove = XLSX.utils.json_to_sheet(dataUnapprove)
      var approve = XLSX.utils.json_to_sheet(dataApprove)
      var cancel = XLSX.utils.json_to_sheet(dataItemCancel)
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, data, 'รายการคำขอ') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, approve, 'รายการอนุมัติ') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, unapprove, 'รายการไม่อนุมัติ') // sheetAName is name of Worksheet
      XLSX.utils.book_append_sheet(wb, cancel, 'รายการยกเลิก') // sheetAName is name of Worksheet
      this.monthStart = this.getMonthTh()
      let date = new Date()
      this.year = moment().format('YYYY')
      this.day = date.getDate()
      XLSX.writeFile(
        wb,
        'ลา(' + this.day + ' ' + this.monthStart + ' ' + this.year + ').xls'
      ) // name of the file is 'book.xlsx'
    },
    async getEmployee () {
      this.dataItemEmployee = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/system_user/getList',
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          console.log('response.data', response.data)
          let rs = response.data
          // console.log(rs)
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            // s = d.empFull_NameTH
            s.value = d
            s.text = '[' + d.empCode + ']' + d.empFull_NameTH
            this.dataItemEmployee.push(s)
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          // this.formAdd.empCodeHeader = null
          console.log(error)
        })
    },
    async getDataLeaveByEmployee () {
      console.log('profile', this.profile)
      this.formAdd.leavePhoneEmergency = this.profile.empTel
      if (this.profile) {
        await this.getDataLeaveByProfile()
      }
    },
    async getDataLeaveByProfile () {
      await this.getEmployeeHeader()
      await this.getEmployeeApprovePermission()
      await this.getDataLeave()
      await this.getDataLeaveQuota()
      await this.getDataLeaveTypeByProfile()
    },
    async getEmployeeHeader () {
      this.dataItemHeader = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/employee/" + "getHeader",
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          let rs = response.data
          // console.log(rs)
          for (var i = 0; i < rs.length; i++) {
            var d = rs[i]
            var s = {}
            // s = d.empFull_NameTH
            s.value = d.empCode
            s.text = d.empFull_NameTH
            this.dataItemHeader.push(s)
          }
          // console.log('getDatadataItemHeader : ', this.dataItemHeader)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    async getEmployeeApprovePermission () {
      this.formAdd.empCodeHeader = null
      // var message = 'คำเตือน : ไม่พบข้อมูลหัวหน้าของท่าน ระบบไม่สามารถส่งการแจ้งเตือนได้ กรุณาติดต่อฝ่ายบุคคล'
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/approve_permission/get?empCode=' +
            this.profile.empCode,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          this.formAdd.empCodeHeader = response.data[0].empCodeApprove
          this.formAdd.empCodeHeaderCC1 = response.data[0].empCodeVerify
          this.profileHeader.userLineuserId =
            response.data[0].userLineuserId_approve
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.formAdd.empCodeHeader = null
          console.log(error)
        })
    },
    async getDataLeave () {
      // Clear Data ทุกครั้ง

      this.leaveType = this.leaveType ? this.leaveType : null
      this.monthStart = this.monthStart ? this.monthStart : null
      this.monthEnd = this.monthEnd ? this.monthEnd : null
      this.year = this.year ? this.year : moment().format('YYYY')

      var leaveTypeSerch =
        this.leaveType !== null ? '&leaveTypeCode=' + this.leaveType : ''

      var monthSearch =
        this.monthStart !== null
          ? '&createMonth=' + this.getMonthThToINT(this.monthStart)
          : ''
      var monthEndSearch = (this.monthEnd !== null) ? '&searchEndMonth=' + this.getMonthThToINT(this.monthEnd) : ''

      var url =
        '/leave_data/getByEmp?empCode=' +
        this.profile.empCode +
        '&leaveStartYear=' +
        this.year +
        leaveTypeSerch +
        monthSearch +
        monthEndSearch

      // console.log('url', url)
      this.itemsLeave = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + url,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.itemsLeave = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.itemsLeave = []
          console.log(error)
        })
      await this.clearSearch()
    },
    async getDataLeaveQuota () {
      // Clear Data ทุกครั้ง
      this.itemsLeaveQuota = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/leave_data/getByEmpWaitingApprove?empCode=' +
            this.profile.empCode,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.itemsLeaveQuota = response.data
          // console.log('itemsLeaveQuota', response.data)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    async getDataLeaveTypeByProfile () {
      // Clear Data ทุกครั้ง
      this.itemsLeaveTypeQuota = []
      this.itemsLeaveTypeSelectByProfile = []
      this.itemsQuota = []
      this.formAdd.leaveTypeCode = ''
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/leave_quota/' +
            'position_lavel_get?positionTypeCode=' +
            this.profile.positionTypeCode,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.itemsQuota = []
          if (response.data) {
            let rs = response.data
            // console.log('getDataLeaveType', rs)
            this.itemsQuota = response.data
            for (var i = 0; i < rs.length; i++) {
              var d = rs[i]
              var s = {}
              var dropdown = {}

              dropdown.text = d.quotaLeaveName
              // console.log(s.text)
              dropdown.value = d.quotaLeaveCode
              this.itemsLeaveTypeSelectByProfile.push(dropdown)

              // this.itemsLeave.length
              var sum = 0
              if (this.itemsLeaveQuota.length > 0) {
                let quoSum = 0
                let quoLimit = 0
                this.itemsLeaveQuota.forEach((element) => {
                  if (d.quotaLeaveCode === element.leaveTypeCode) {
                    quoSum += element.leaveSummaryDay
                    quoLimit = d.quotaLeave
                  } else {
                    quoLimit = d.quotaLeave
                  }
                })

                sum = quoLimit - quoSum
              } else {
                sum = d.quotaLeave
              }
              s.text =
              d.quotaLeaveName + ' ( ' + sum + '/ ' + d.quotaLeave + ') วัน'
              // console.log(s.text)
              s.value = d.quotaLeaveCode
              s.quotaLeaveName = d.quotaLeaveName
              s.quota = sum
              s.quotaLeave = d.quotaLeave
              s.leaveOptioneAttached = d.leaveOptioneAttached
              s.leaveConditionAfterDay = d.leaveConditionAfterDay
              this.itemsLeaveTypeQuota.push(s)
            }
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    },
    async calculateStartEndDate () {
      var given = moment(this.formAdd.leaveStartDate, 'YYYY-MM-DD')
      var current = moment(this.formAdd.leaveEndDate, 'YYYY-MM-DD')

      var sumDay = moment.duration(current.diff(given)).asDays() + 1

      sumDay = this.formAdd.leaveStartHalf === 'F' ? sumDay - 0.5 : sumDay
      sumDay = this.formAdd.leaveEndtHalf === 'F' ? sumDay - 0.5 : sumDay
      this.formAdd.leaveSummaryDay = sumDay

      if (sumDay <= 0) {
        // this.formAdd.leaveStartDate = null
        this.formAdd.leaveEndDate = null
        this.formAdd.leaveSummaryDay = 0
      }
      if (
        this.formAdd.leaveStartDate === null ||
        this.formAdd.leaveEndDate === null
      ) {
        this.formAdd.leaveSummaryDay = 0
      }

      // console.log(sumDay)

      this.getDataSummaryLeave(this.formAdd.leaveTypeCode)
    },
    async getDataSummaryLeave (leaveTypeCode) {
      // Clear Data ทุกครั้ง
      var sumLeave = 0
      var leaveCode = ''
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/leave_quota/quotaLeaveCode?quotaLeaveCode=' +
            leaveTypeCode,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          // console.log('quo', response.data)
          sumLeave = response.data.quotaLeave
          leaveCode = response.data.quotaLeaveCode
          // this.imageUrlleve = response.data.leaveImgUrl
          this.itemsLeaveSelect = response.data
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/leave_data/getByEmpNotInCancel?empCode=' +
            this.profile.empCode +
            '&leaveStartYear=' +
            moment().format('YYYY') +
            '&leaveTypeCode=' +
            leaveTypeCode,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          console.log('response.data.length', response.data)
          console.log('leaveCode', leaveCode)
          var countLeave = 0
          response.data.find((d) => {
            if (d.leaveTypeCode === leaveCode) {
              console.log('response.data.length', d.quotaLeaveName)
              countLeave += d.leaveSummaryDay
            }
          })
          console.log('str', countLeave)
          sumLeave -= countLeave
          console.log('sumLeave', sumLeave)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })

      // console.log('sumLeave', sumLeave)
      this.sumLeave = sumLeave
    },
    async calculateIssueBeforeDay () {
      // console.log('calculateIssueBeforeDay')
      //  dateMin: moment().subtract(2, 'd').format('YYYY-MM-DD')
      // console.log(moment().subtract(2, 'd').format('YYYY-MM-DD'))
      // console.log(moment().subtract(35, 'd').format('YYYY-MM-DD'))
      this.dateMin = moment().subtract(180, 'd').format('YYYY-MM-DD')
    },
    async submit () {
      this.dataReady = false
      this.valid_add = false

      console.log(this.files)
      if (this.files) {
        await this.fileupload()
      }
      if (this.files2) {
        await this.fileupload2()
      }

      // ดึงข้อมูลโควต้า โดย รหัสประเภทโควต้า
      console.log('1 => getDataQuotaByName')
      var quota = await this.getDataQuotaByName(this.formAdd.leaveTypeCode)
      console.log('quota', quota)
      // เงือนไขการลาฉุกเฉิน และ แนบไฟล์ และ โควต้าการลา  และ ลาย้อนหลัง
      console.log('2 => checkOptionCondition')
      var condition = await this.checkOptionCondition(this.formAdd, quota)
      console.log('condition', condition)
      // ตรวจสอบวันซ้ำ
      console.log('3 => checkDateDup')
      var checkDateDup = await this.checkDateDup(this.formAdd)
      console.log('checkDateDup', checkDateDup)
      if (condition && checkDateDup === false) {
        console.log('4 -> setUpApprove')
        // await this.getDataEmpHeaderCC(this.formAdd.empCodeHeaderCC1)
        // console.log(this.files2)
        await this.setUpApprove()
      }
    },
    async getDataQuotaByName (leaveTypeCode) {
      return axios.get(
        // eslint-disable-next-line quotes
        this.DNS_IP +
          '/leave_quota/quotaLeaveCode?quotaLeaveCode=' +
          leaveTypeCode,
        {
          headers: {
            'Application-Key': this.$session.getAll().ApplicationKey
          }
        }
      )
    },
    // เงือนไขการลาฉุกเฉิน และ แนบไฟล์ ลาย้อนหลัง
    checkOptionCondition (formAdd, quota) {
      var check = true
      var textError1 = ''
      if (this.sumLeave < formAdd.leaveSummaryDay) {
        check = false
        textError1 =
          '- โควต้าการลา ' + quota.data.quotaLeaveName + ' ไม่เพียงพอ'
        this.formAdd.leaveStartDate = null
        this.formAdd.leaveEndDate = null
      }

      if (check === false) {
        this.valid_add = true
        this.$swal({
          html:
            'กรุณาตรวจสอบดังนี้  <br> ' + textError1,
          type: 'question',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'ใช่'
        })
      }

      return check
    },
    // ตรวจสอบวันลาซ้ำ
    checkDateDup (formAdd) {
      var check = false
      var d = []
      this.itemsLeaveQuota.forEach((element) => {
        var s = ''
        s = this.dateCheck(
          formAdd.leaveStartDate,
          formAdd.leaveEndDate,
          element.leaveStartDate
        )
        // console.log('c', s)
        d.push(s)
      })

      check = d.includes(true)
      if (check) {
        this.$swal({
          html:
            'พบวันลาซ้ำ กรุณาตรวจสอบวันลาใหม่ของท่านในวันที่ ' +
            formAdd.leaveStartDate +
            ' ถึง ' +
            formAdd.leaveEndDate,
          type: 'question',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'ใช่'
        })
        this.formAdd.leaveStartDate = null
        this.formAdd.leaveEndDate = null
      }

      return check
    },
    dateCheck (from, to, check) {
      let fDate, lDate, cDate
      fDate = moment(from).format('YYYY-MM-DD')
      lDate = moment(to).format('YYYY-MM-DD')
      cDate = moment(check).format('YYYY-MM-DD')
      if (cDate <= lDate && cDate >= fDate) return true
      return false
    },
    async setUpApprove () {
      let ds = {
        empCode: this.profile.empCode,
        userLineuserId: this.profile.userLineuserId,
        leaveStartDate: this.formAdd.leaveStartDate,
        leaveStartDay: moment(this.formAdd.leaveStartDate).format('DD'),
        leaveStartMonth: moment(this.formAdd.leaveStartDate).format('MM'),
        leaveStartYear: moment(this.formAdd.leaveStartDate).format('YYYY'),
        leaveStartHalf: this.formAdd.leaveStartHalf,
        leaveEndDate: this.formAdd.leaveEndDate,
        leaveEndDay: moment(this.formAdd.leaveEndDate).format('DD'),
        leaveEndMonth: moment(this.formAdd.leaveEndDate).format('M'),
        leaveEndYear: moment(this.formAdd.leaveEndDate).format('YYYY'),
        leaveEndtHalf: this.formAdd.leaveEndtHalf,
        empCodeHeader: this.formAdd.empCodeHeader,
        userLineuserIdHeader: this.profileHeader.userLineuserId,
        empCodeHeaderCC1: this.formAdd.empCodeHeaderCC1,
        // userLineuserIdHeaderCC: this.profileHeaderCC.userLineuserId,
        leaveDetail: this.formAdd.leaveDetail,
        leavePhoneEmergency: this.formAdd.leavePhoneEmergency,
        leaveSummaryDay: this.formAdd.leaveSummaryDay,
        leaveTypeCode: this.formAdd.leaveTypeCode,
        leaveStatus: 'waiting',
        leaveFile: this.formAdd.leaveFile,
        leaveFile2: this.formAdd.leaveFile2,
        leaveEmergency: this.formAdd.leaveEmergency,
        leaveIssueBeforeDay: this.formAdd.leaveIssueBeforeDay
      }
      console.log('addData', ds)
      this.addData(ds)
    },
    async addData (ds) {
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/leave_data" + "/add",
          ds,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          await this.setUpBeforeSendLine(ds)
          await this.getData()
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error leave_data : ', error)
        })
      this.dataReady = true
      this.dialogAdd = false
    },
    async setUpBeforeSendLine (item) {
      var payload = [
        {
          type: 'flex',
          altText:
            this.profile.empFull_NameTH +
            '[ขอ' +
            this.itemsLeaveSelect.quotaLeaveName +
            ']',
          contents: {
            type: 'bubble',
            size: 'giga',
            body: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'image',
                  url: this.itemsLeaveSelect.leaveImgUrl,
                  size: '60%',
                  gravity: 'center'
                }
              ],
              paddingAll: '0px'
            },
            footer: {
              type: 'box',
              layout: 'vertical',
              contents: [
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text:
                        'คำขออนุมัติ ' + this.itemsLeaveSelect.quotaLeaveName,
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: 'รออนุมัติ',
                      wrap: true,
                      align: 'center',
                      size: '26px'
                    }
                  ],
                  margin: '10px'
                },
                {
                  type: 'box',
                  layout: 'vertical',
                  contents: [
                    {
                      type: 'text',
                      text: this.profile.empFull_NameTH,
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text:
                        'เริ่มวันที่ ' +
                        item.leaveStartDate +
                        ' ถึง ' +
                        item.leaveEndDate,
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text: 'จำนวนวันลา ' + item.leaveSummaryDay + ' วัน',
                      wrap: true,
                      align: 'center'
                    },
                    {
                      type: 'text',
                      text:
                        'วันที่ทำรายการ ' +
                        moment().format('YYYY-MM-DD HH:mm:ss'),
                      wrap: true,
                      align: 'center'
                    }
                  ],
                  margin: '10px'
                },
                {
                  type: 'button',
                  action: {
                    type: 'uri',
                    label: 'ตรวจสอบประวัติ',
                    uri: 'line://app/1654154168-YKeLVJoP'
                  },
                  adjustMode: 'shrink-to-fit',
                  style: 'secondary',
                  margin: '10px'
                }
              ]
            }
          }
        }
      ]
      await this.setlineUser(item, payload)
      // await this.setlineUser(item, payload, payloadCC)
      this.dataReady = false
    },
    async fileupload () {
      const _this = this
      let params = new FormData()
      // _this.data = JSON.parse(localStorage.getItem('data'))
      params.append('file', _this.files)
      params.append('profile', _this.profile)
      console.log('this.files', _this.files)
      console.log('this.files', _this.files.size)
      if (_this.files.size < 2000000) {
        try {
          await axios
            .post(_this.DNS_IP + '/leave_data/upload', params, {
              headers: {
                'Application-Key': _this.$session.getAll().ApplicationKey,
                Code: _this.profile.empCode
              }
            })
            .then(function (response) {
              console.log('file1', response.data)
              _this.formAdd.leaveFile = _this.DNS_IP + '/' + response.data
            }).catch((error) => {
              alert(error)
              return null
            })
        } catch (error) {
          alert(error)
        }
        console.log('this.files', _this.files)
        console.log('this.files', _this.files.size)
      }
    },
    async fileupload2 () {
      const _this = this
      let params = new FormData()

      if (_this.files2.size < 2000000) {
        // _this.data = JSON.parse(localStorage.getItem('data'))
        params.append('file', _this.files2)
        params.append('profile', _this.profile)

        try {
          await axios
            .post(_this.DNS_IP + '/leave_data/upload', params, {
              headers: {
                'Application-Key': _this.$session.getAll().ApplicationKey,
                Code: _this.profile.empCode
              }
            })
            .then(function (response) {
              // console.log('file2', response)
              _this.formAdd.leaveFile2 = _this.DNS_IP + '/' + response.data
            })// eslint-disable-next-line handle-callback-err
            .catch((error) => {
              alert(error)
              return null
            })
        } catch (error) {
          alert(error)
        }

        console.log('this.files2', _this.formAdd.leaveFile2)
      }
    },
    clearSearch () {
      this.files = null
      this.files2 = null
      this.formAdd.leaveFile = null
      this.formAdd.leaveFile2 = null
      this.formAdd.leaveEmergency = false
      this.formAdd.leaveIssueBeforeDay = false
    }
  }
}
</script>
<style scope>
:root {
  --table-head-text: #ffffff;
  --table-body-row-even: #b1c9ea;
  --table-body-row-odd: #ffffff;
}
.v-data-table-header {
  background-color: #1b437c !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/Leave/LeaveData.vue